import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/heighttechnologies.webp';
import screenshot_target from '../../../images/letterfunnel/ernstthijsen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ernst Thijsen"
      firstname="Ernst"
      companyname="Height Technologies"
      competition="DeltaQuad en Acecore Technologies"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ernstthijsen.js